import axios from 'axios';

const getCompras = params => axios.get('/compras', {
  params,
});

const getComprasList = params => axios.get('/compras/list', {
  params,
});

const getCompra = id => axios.get(`/compras/${id}`, {});
const getCompraCompleto = id => axios.get(`/compras/${id}/completo`, {});
const getCompraProdutos = id => axios.get(`/compras/produtos/${id}`, {});
const cancelar = (id, compra) => axios.put(`/compras/${id}/cancelar`, compra);
const aprovar = (id, compra) => axios.put(`/compras/${id}/aprovar`, compra);
const aprovarComprador = (id, compra) => axios.put(`/compras/${id}/aprovar-comprador`, compra);

const save = (compra, isPendenteFornecedor, isRascunho) => {
  if (compra.id && isPendenteFornecedor && isRascunho) {
    return axios.put(`/compras/pendente-fornecedor/${compra.id}`, compra);
  }
  if (compra.id && isRascunho) {
    return axios.put(`/compras/${compra.id}/rascunho-compra`, compra);
  }
  if (compra.id) {
    return axios.put(`/compras/${compra.id}`, compra);
  }
  if (isPendenteFornecedor) {
    return axios.post('/compras/pendente-fornecedor', compra);
  }
  return axios.post('/compras', compra);
};

// Esse endpoint faz update de alguns campos sem passar por aprovação ou notificação
const updateCompra = compra => axios.put(`compras/edit/${compra.id}`, compra);

const saveRascunho = (rascunho) => {
  if (rascunho.id) {
    return axios.put(`/compras/rascunhos/${rascunho.id}`, rascunho);
  }
  return axios.post('/compras/rascunhos', rascunho);
};

const removerRascunho = id => axios.delete(`/compras/rascunhos/${id}`);

const remover = id => axios.delete(`/compras/${id}`);

const notificarMensagem = id => axios.post(`/notificacoes/compras/${id}`, {});

const savePrevisaoEntrega = (id, data) => axios.put(`compras/${id}/previsao-entrega`, data);

const getFromRequisicao = idRequisicao => axios.get(`/requisicoes/${idRequisicao}/compra`);

const getFromRequisicaoProdutos = data => axios.post('/requisicoes/compra', data);

const finalizarEntrega = id => axios.put(`compras/${id}/entregas`, {});

const reenviarEmail = id => axios.put(`compras/${id}/finalizacao-compra`, id);

const reenviarWhatsapp = id => axios.put(`compras/${id}/whatsapp`, id);

const getLinks = id => axios.get(`compras/${id}/links`);

const generatePdf = id => axios.get(`/compras/${id}/pdf`);

const atualizarValorMoeda = (id, data) => axios.put(`/compras/${id}/moeda`, data);

export default {
  getCompra,
  getComprasList,
  getCompraCompleto,
  getCompras,
  getCompraProdutos,
  cancelar,
  aprovar,
  save,
  remover,
  saveRascunho,
  removerRascunho,
  notificarMensagem,
  savePrevisaoEntrega,
  aprovarComprador,
  getFromRequisicao,
  getFromRequisicaoProdutos,
  finalizarEntrega,
  reenviarEmail,
  reenviarWhatsapp,
  updateCompra,
  getLinks,
  generatePdf,
  atualizarValorMoeda,
};
